<template>
  <div id="page_app">
    <v-card class="mt-4">
      <v-data-table
        :headers="complex.headers"
        :items="delete_akuns || []"
        class="elevation-1"
        item-key="id"
        :loading="loading"
        :options.sync="opsi"
        :server-items-length="totaldata"
      >
        <template v-slot:progress>
          <v-skeleton-loader
            v-if="loading"
            transition="fade-transition"
            type="table-tbody"
          >
          </v-skeleton-loader>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="text-xs-left">
            <v-chip
              v-if="item.status === 1"
              color="green"
              small
              text-color="white"
              >{{ statusformat(item.status) }}</v-chip
            >
            <v-chip v-else color="ongoing" small>{{
              statusformat(item.status)
            }}</v-chip>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="text-xs-left">
            <div v-if="item.status === 0">
              <!-- <v-btn @click.native="updateStatus(item)" small>
                Approve
              </v-btn> -->
              <!-- <v-btn
                class="flex-grow-1"
                height="48"
                variant="tonal"
                color="blue"
                small
                text-color="white"
                @click.native="updateStatus(item)"
              >Approve</v-btn> -->
              <v-btn color="blue" class="white--text" @click.native="updateStatus(item)">Approve <i class="fa fa-check" aria-hidden="true"></i></v-btn>
            </div>
          </div>
        </template>
        <template v-slot:item.createdat="{ item }">
          <div class="text-xs-left">
            {{ formattime(item.createdat) }}
            <!-- <div v-if="item.status === 0">
              <v-btn @click.native="openFormEdit(item)" icon small>
                <v-icon color="primary">done</v-icon>
              </v-btn>
              <v-btn @click.native="deleteItem(item)" icon small>
                <v-icon color="red">dangerous</v-icon>
              </v-btn>
            </div> -->
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Delete_Akun",
  data: () => ({
    search: "",
    dialog: false,
    dialogListMenu: false,
    valid: false,
    Rules: [(v) => !!v || "Please fill input"],
    title: "",
    searchKategori: "",
    kategoriData: {
      title: "",
      status: "",
      showHome: "",
      sort: "",
      menus: [],
    },
    listMenuKategori: [],
    dataListMenu: [],
    // optionStatus: [
    //   { text: "Enable", value: 1 },
    //   { text: "Disable", value: 0 },
    // ],
    // optionShow: [
    //   { text: "YES", value: 1 },
    //   { text: "NO", value: 0 },
    // ],
    complex: {
      headers: [
        {
          text: "Server ID",
          value: "id_reseller",
        },
        {
          text: "Nama Reseller",
          value: "name_reseller",
        },
        {
          text: "UUID",
          value: "uuid",
        },
        {
          text: "Created At",
          value: "createdat",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    },
    opsi: {
      search: "",
      itemsPerPage: 10,
      page: 1,
      sortBy: ["asc"],
    },
    opsiMenu: {
      search: "",
      itemsPerPage: 1000,
      page: 1,
      sortBy: ["id"],
    },
  }),

  watch: {
    opsi: {
      handler() {
        const send = {
          page: this.opsi.page,
          size: this.opsi.itemsPerPage
        }
        this.getDataDeleteAkun(send);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("DeleteAkun", ["loading","delete_akuns","totaldata","totalpage"]),
  },
  methods: {
    ...mapActions("DeleteAkun",["getDataDeleteAkun","updateStatusDeleteAkun"]),
    statusformat (value) {
      let a = 'Pending'
      if (value === 1) {
        a = 'Ok'
      }
      return a
    },
    formattime(time){
      return moment(time).format("YYYY-MM-DD")
    },
    updateStatus(data) {
      const send = {
        id_reseller: data.id_reseller,
        uuid: data.uuid,
        status: 1
      }
      this.$confirm('Apakah anda yakin menyetujui hapus akun?', { color: 'red',title:'Konfirmasi',icon:'fa-warning' }).then(res => {
        if (res) {
          this.updateStatusDeleteAkun(send)
        }
      })
    },
    // refresh() {
    //   // (this.opsi = {
    //   //   itemsPerPage: 10,
    //   //   page: 1,
    //   // }),
    //     this.getDataDeleteAkun();
    // },
    // async openFormEdit(data) {
    //   this.title = "Edit Kategori";
    //   this.getMenuApps(this.opsiMenu);
    //   let menuData = []
    //   data.listMenu.forEach(element => {
    //       menuData.push(element.id)
    //   });
    //   let dataKategori = {
    //       "id": data.id,
    //     "title": data.title,
    //     "status": data.status,
    //     "showHome": data.showHome,
    //     "sort": data.sort,
    //     "menus": menuData
    //     }
    //   this.kategoriData = dataKategori;
    //   console.log(dataKategori);
    //   this.dialog = true;
    // },
    // openModal(title) {
    //   this.kategoriData = {
    //     title: "",
    //     status: "",
    //     showHome: "",
    //     sort: "",
    //     menus: [],
    //   };
    //   this.getMenuApps(this.opsiMenu);
    //   this.title = title;
    //   this.dialog = true;
    // },
    // openDialogListMenu(data) {
    //   this.dialogListMenu = true;
    //   this.dataListMenu = data
    // },
    // closeDialogListMenu() {
    //     this.dialogListMenu = false;
    //   this.dataListMenu = []
    // },
    // closeDialog() {
    //   this.title = "";
    //   this.kategoriData = {
    //     title: "",
    //     status: "",
    //     showHome: "",
    //     sort: "",
    //     menu: [],
    //   };
    //   this.dialog = false;
    // },
    // async saveForm(data) {
    //   console.log(data);
    //   await this.Add(data);
    //   this.closeDialog();
    // },
    // async saveEdit(data){
    //     console.log(data);
    //     await this.Edit(data)
    //     this.closeDialog();
    // },
    // deleteItem(data) {
    //   if (confirm("Are you sure you want delete ?")) {
    //     this.Delete({ id: data.id, opsi: this.opsi });
    //   }
    // },
    // statusformat (value) {
    //   let a = 'Disable'
    //   if (value === 1) {
    //     a = 'Enable'
    //   }
    //   return a
    // },
    // showHomeformat (value) {
    //   let a = 'NO'
    //   if (value === 1) {
    //     a = 'YES'
    //   }
    //   return a
    // },
  },
};
</script>

<style lang="stylus" scoped>
.irma-image-priview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 150px;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 4px #ccc;
  box-shadow: 0 0 4px #ccc;
}

.imgupload-mask {
  width: 100%;
  max-width: 180px;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.iconupload {
  position: absolute;
  top: 0;
}

.quill {
  height: 300px;
  padding-bottom: 95px;
}

.imgslidelist {
  width: 32px;
  height: 32px;
}

.tdlist {
  padding: 4px !important;
}

.padr {
  padding-right: 10px !important;
}

.tdr {
  padding-left: 30px !important;
}
</style>